import createApi from 'lyjs/es/request/createApi'

import {OSS_ENDPOINT} from 'services/config'

const Oss = createApi({
  baseURL: OSS_ENDPOINT
})

export default Oss



// WEBPACK FOOTER //
// ./src/services/request/Oss.js